import { Badge, Skeleton, Text } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { memo } from 'react';

import { AppLink } from 'components/appLink';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { useQueueDashboardQueueContext } from '../../queueDashboardQueue.context';
import { QueueDashboardQueueFavoriteToggle } from '../favoriteToggle/queueDashboardQueueFavoriteToggle';
import { QueueDashboardQueueFavoriteToggleOld } from '../favoriteToggleOld/queueDashboardQueueFavoriteToggleOld';

import styles from './queueDashboardQueueTitle.module.scss';

export const QueueDashboardQueueTitle = memo(
  function QueueDashboardQueueTitle(): JSX.Element {
    const { isSkeleton, ...context } = useQueueDashboardQueueContext();
    const queue = context.queue!;

    const flags = useFeatureFlag(['dashboard-enhanced-favorites']);

    return (
      <div className={styles.title}>
        {flags.dashboardEnhancedFavorites ? (
          <QueueDashboardQueueFavoriteToggle />
        ) : (
          <QueueDashboardQueueFavoriteToggleOld />
        )}

        {isSkeleton ? (
          <Skeleton height="20px" width="120px" />
        ) : (
          <>
            <AppLink
              path="/conversations"
              params={{
                search: {
                  queue: [queue.id],
                  status: ['open'],
                },
              }}
              onClick={() => {
                ampli.dashboardQueueNameClicked();
              }}
            >
              <Text.Heading variant="heading-3">{queue.name}</Text.Heading>
            </AppLink>

            {queue.is_default && (
              <Badge variant="primary" size="small">
                Default
              </Badge>
            )}

            {queue.is_archived && (
              <Badge variant="error" size="small">
                Archived
              </Badge>
            )}
          </>
        )}
      </div>
    );
  },
);
